import { GallerySearchMode } from '../models/gallery-search-mode.enum';
import { StudioOptionsModel } from '../models/studio-options.model';
import { GalleryViewMode } from '../models/gallery-view-mode.enum';
import { ListValue } from 'src/app/modules/modules.service';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';

export namespace GalleryActions {
  export class SetSearchMode {
    static readonly type = '[Gallery] Set Search Mode';
    constructor(public searchMode: GallerySearchMode) { }
  }

  export class SetViewMode {
    static readonly type = '[Gallery] Set View Mode';
    constructor(public viewMode: GalleryViewMode) { }
  }

  export class SetSort {
    static readonly type = '[Gallery] Set Sort';
    constructor(public sort: BookmarkSortModel) { }
  }
  
  export class GetStudioOptions {
    static readonly type = '[Gallery] Get Studio Options';
    constructor(public organizationId?: number) { }
  }
  
  export class GetStudioOptionsSuccess {
    static readonly type = '[Gallery] Get Studio Options Success';
    constructor(public options: StudioOptionsModel[]) { }
  }

  export class SearchLoft {
    static readonly type = '[Gallery] Search Loft';
    constructor(public primaryCategory: string, public secondaryCategory?: string, public name?: string) { }
  }

  export class SearchLoftSuccess {
    static readonly type = '[Gallery] Search Loft Success';
    constructor(public bookmarks: ListValue[]) { }
  }

  export class SearchStudio {
    static readonly type = '[Gallery] Search Studio';
    constructor(public category: StudioOptionsModel, public query: string) { }
  }

  export class SearchStudioSuccess {
    static readonly type = '[Gallery] Search Studio Success';
    constructor(public bookmarks: BookmarkModel[]) { }
  }

  export class SearchSuccess {
    static readonly type = '[Gallery] Search Success';
    constructor(public bookmarks: BookmarkModel[]) { }
  }

  export class SelectBookmark {
    static readonly type = '[Gallery] Select Bookmark';
    constructor(public result: BookmarkModel) { }
  }

  export class ClearResults {
    static readonly type = '[Gallery] Clear Results';
    constructor() { }
  }

  export class Reset {
    static readonly type = '[Gallery] Reset';
    constructor() { }
  }
}
